module.exports = __webpack_public_path__ + "static/media/1.b7866b37.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/images/16463/1.jpg
// module id = 561
// module chunks = 0